export default __webpack_public_path__ + "static/media/logo-spotify.329bc760.svg";